import script from "./ContractorDetailsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContractorDetailsCard.vue?vue&type=script&lang=ts&setup=true"

import "./ContractorDetailsCard.vue?vue&type=style&index=0&id=9acaa200&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9acaa200"]])

export default __exports__